// extracted by mini-css-extract-plugin
export default {"cls1":"CookieConsent-Text_cls1__Og54D","cls2":"CookieConsent-Text_cls2__yJWyE CookieConsent-Text_cls1__Og54D"};